//Loại mẫu
export default {
  Template: 0,
  Designed : 1
};
